import { createChunkFormData } from "./utils";
import { postFormWithAuth, fetchWithAuth } from "../apiutil";

export const uploadQueueAPI = {
  uploadChunk: async (
    accessToken,
    caseId,
    clipId,
    chunk,
    fileObject,
    fileData,
    fileHash,
    comment = ""
  ) => {
    console.log(
      `[uploadQueueAPI.uploadChunk] Uploading chunk ${chunk.chunkIndex + 1}/${
        chunk.totalChunks
      } for ${chunk.fileName}`
    );

    try {
      const endpoint = `/api/cases/${caseId}/clips/${clipId}/upload/file`;

      const formData = createChunkFormData(
        chunk,
        fileObject,
        fileData,
        fileHash,
        comment
      );
      const result = await postFormWithAuth(
        endpoint,
        {
          method: "POST",
          body: formData,
        },
        accessToken
      );

      if (result.success) {
        return {
          success: true,
          data: result.data,
          progress: {
            chunkIndex: chunk.chunkIndex,
            totalChunks: chunk.totalChunks,
          },
        };
      }

      return {
        success: false,
        error: result.error || "Upload failed",
        chunkIndex: chunk.chunkIndex,
      };
    } catch (error) {
      console.error(
        `[uploadQueueAPI.uploadChunk] Error uploading chunk ${chunk.chunkIndex} for ${chunk.fileName}:`,
        error
      );
      return {
        success: false,
        error: error.message || "Network error during upload",
        chunkIndex: chunk.chunkIndex,
      };
    }
  },
  start: async (accessToken, caseId, clipId) => {
    try {
      const endpoint = `/api/cases/${caseId}/clips/${clipId}/upload/start`;
      const result = await postFormWithAuth(
        endpoint,
        {
          method: "POST",
        },
        accessToken
      );

      if (result.success) {
        return {
          success: true,
          data: result.data,
        };
      }

      return {
        success: false,
        error: result.error || "Failed to start upload",
      };
    } catch (error) {
      console.error(
        `[uploadQueueAPI.start] Error starting upload for case ${caseId}, clip ${clipId}:`,
        error
      );
      return {
        success: false,
        error: error.message || "Network error during upload",
      };
    }
  },
  cancel: async (accessToken, caseId, clipId) => {
    try {
      const endpoint = `/api/cases/${caseId}/clips/${clipId}/upload/reset`;
      const result = await fetchWithAuth(
        endpoint,
        {
          method: "GET",
        },
        accessToken
      );

      if (result.success) {
        return {
          success: true,
          data: result.data,
        };
      }

      return {
        success: false,
        error: result.error || "Failed to cancel upload",
      };
    } catch (error) {
      console.error(
        `[uploadQueueAPI.cancel] Error cancelling upload for case ${caseId}, clip ${clipId}:`,
        error
      );
      return {
        success: false,
        error: error.message || "Network error during upload",
      };
    }
  },
};
